import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HeaderHelperService } from '../header-helper.service';
import { CreateChatModel } from '../../models/chat/create-chat-model';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService
  ) {}

  chatList(patientRecordCaseId: string): Observable<any> {
    let url = `${environment.apiLocations.chat}/Chat/${patientRecordCaseId}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  chat(createChatModel: CreateChatModel): Observable<any> {
    const url = `${environment.apiLocations.chat}/Chat/${createChatModel.patientRecordCaseId}`;
    const formData: FormData = new FormData();
    formData.append('PatientRecordCaseId', createChatModel.patientRecordCaseId);
    formData.append('PatientName', createChatModel.patientName);
    formData.append('PatientSurname', createChatModel.patientSurname);
    formData.append(
      'PatientRecordCaseNumber',
      createChatModel.patientRecordCaseNumber.toString()
    );
    formData.append('CreatedUserName', createChatModel.createdUserName);
    formData.append('ExpertUserName', createChatModel.expertUserName);
    formData.append(
      'GeneralPractitionerUserName',
      createChatModel.generalPractitionerUserName
    );
    formData.append('Message', createChatModel.message);

    if (createChatModel.file) {
      formData.append('File', createChatModel.file, createChatModel.file.name);
    }

    return this.http.post<any>(url, formData, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  userAvatars(data: any): Observable<any> {
    return this.http.post<any>(
      `${environment.apiLocations.identity}/Users/GetUserAvatars`,
      data,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  getUnreadChatCount(caseIds: any): Observable<any> {
    return this.http.post<any>(
      `${environment.apiLocations.chat}/Chat/GetUnreadChatCount`,
      caseIds,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  markMessagesAsRead(caseId: string): Observable<any> {
    let url = `${environment.apiLocations.chat}/Chat/MarkMessagesAsRead/${caseId}`;

    return this.http.put<any>(
      url,
      {},
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }
}
